import index from '../objects/page/index'

index()
